import Nav from "@/components/lumos/Nav";
import Hero from "@/components/lumos/Hero";
import KeyFigures from "@/components/lumos/KeyFigures";
import Services from "@/components/lumos/Services";
import Pricing from "@/components/lumos/Pricing";
import WhyLumos from "@/components/lumos/WhyLumos";
import Process from "@/components/lumos/Process";
import ZoneMap from "@/components/lumos/ZoneMap";
import Testimonials from "@/components/lumos/Testimonials";
import Contact from "@/components/lumos/Contact";
import Footer from "@/components/lumos/Footer";

export default function Landing() {
    return (
        <main data-testid="landing-page" className="bg-lumos-bg min-h-screen overflow-x-hidden">
            <Nav />
            <Hero />
            <KeyFigures />
            <Services />
            <Pricing />
            <WhyLumos />
            <Process />
            <ZoneMap />
            <Testimonials />
            <Contact />
            <Footer />
        </main>
    );
}
